"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const theme_1 = require("../../components/theme");
exports.CSS = {
    container: 'c-ExportNotification',
    section: 'c-ExportNotificaion__section',
    title: 'c-ExportNotification__title',
    content: 'c-ExportNotification__content',
    modal: 'c-ExportNotification__modal'
};
exports.Style = {
    [exports.CSS.container]: {
        color: theme_1.DefaultTheme.font.color.primary
    },
    [exports.CSS.section]: {
        'padding-bottom': theme_1.DefaultTheme.space(1)
    },
    [exports.CSS.title]: {
        'font-weight': theme_1.DefaultTheme.font.weight.bold
    },
    [exports.CSS.content]: {
        'list-style': 'none',
        margin: 0
    },
    [exports.CSS.modal]: {
        'min-width': '650px'
    }
};
//# sourceMappingURL=export.notification.style.js.map